import { ILicenceProfile } from "../../api/ILicenceProfile";
import EpaCard from "../../leap-components/EpaCard";
import EpaField from "../../leap-components/EpaField";

interface ILicenceDetailsProps {
  licenceProfile: ILicenceProfile;
}

const LicenceDetails = ({ licenceProfile }: ILicenceDetailsProps) => {
  var bodyElements = (
    <div>
      <EpaField label={"Organisation"} value={licenceProfile.organisation} />
      <EpaField label={"Name"} value={licenceProfile.profileName} />
      <EpaField label={"Number"} value={licenceProfile.profileNo} />
      <EpaField label={"County"} value={licenceProfile.county} />
    </div>
  ) as JSX.Element;

  return <EpaCard title={"Authorisation Details"} content={bodyElements} />;
};

export default LicenceDetails;
